import styled from 'styled-components';

import { inputFocus } from '@xemplo/input-utils';
import { XemploInput } from '@xemplo/xemplo-input';

/** This styling simulates the container to be on a focus state */
export const CustomXemploInput = styled(XemploInput)`
  &.open,
  &:focus-within:not(.invalid) {
    ${inputFocus};
  }

  &.not-searchable {
    > input {
      cursor: default;
      caret-color: transparent;
    }
  }

  svg.trailing {
    font-size: 16px;
    transition: transform 0.1s ease-out;

    &.open {
      transform: rotate(180deg);
    }
  }
`;
